import uuid from '../utils/uuid.utils';

export class TrackingEvent {
  static Events = {
    ONBOARDING_START_SHOW: 'onboarding_start_show',
    ONBOARDING_SUCCESS: 'onboarding_success',
    ONBOARDING_BACK_TAP: 'onboarding_back_tap',
    ONBOARDING_CONTINUE_BUTTON_TAP: 'onboarding_continue-button_tap',
    CREDIT_ONBOARDING_CONTINUE_BUTTON_TAP:
      'credit_onboarding_continue-button_tap',
    ONBOARDING_LEAVE_TAP: 'onboarding_leave_tap',
    CREDIT_ONBOARDING_LEAVE_TAP: 'credit_onboarding_leave_tap',
    ONBOARDING_ERROR_SHOW: 'onboarding_error_show',
    ONBOARDING_FEEDBACK_SHOW: 'onboarding_ID-feedback_show',
    PERMISSION_LOCATION_SHOW: 'permission_location_show',
    PERMISSION_LOCATION_SELECTED: 'permission_location_selected',
    LOCATION_LIST_TAP: 'location_list_tap',
    PICKUP_ERROR_SHOW: 'pickup_error_show',
    ACTIVATION_CODE_SCREEN_SHOW: 'activation_code_screen_show',
    ACTIVATION_IN_PROGRESS_SCREEN_SHOW: 'activation_in_progress_screen_show',
    ACTIVATION_LEAVE_TAP: 'activation_leave_tap',
    ACTIVATION_ERROR_SHOW: 'activation_error_show',
    SET_PIN_SCREEN_SHOW: 'set_pin_screen_show',
    SET_PIN_SUCCESS_SCREEN_SHOW: 'set_pin_success_screen_show',
    CARD_SETTING_SCREEN_SHOW: 'card_setting_screen_show',
    RESET_PIN_TAP: 'reset_pin_tap',
    PIN_CHANGE_SUCCESS_SCREEN_SHOW: 'pin_change_success_screen_show',
    REPORT_CARD_ENTRY_POINT_TAP: 'report_card_entry_point_tap',
    REPORT_CARD_BALANCE_ENOUGH_SHOW: 'report_card_balance_enough_show',
    REPORT_CARD_BALANCE_NOT_ENOUGH_SHOW: 'report_card_balance_not_enough_show',
    REPORT_CARD_NOT_ACTIVE_SHOW: 'report_card_not_active_show',
    REPORT_CARD_REPRINT_TAP: 'report_card_reprint_tap',
    REPORT_CARD_REPRINT_CONFIRMATION_SHOW:
      'report_card_reprint_confirmation_show',
    REPORT_CARD_REPRINT_ERROR_SHOW: 'report_card_reprint_error_show',
    LOCK_CARD_TRUE: 'lock_card_true',
    LOCK_CARD_FALSE: 'lock_card_false',
    DISCOVER_LOAD_FEED: 'discover_load_feed',
    DISCOVER_TAP_ACTION: 'discover_tap_action',
    DISCOVER_LOAD_FEED_ERROR: 'discover_load_feed_error',
    DISCOVER_BANNER_VIEW: 'discover_banner_view',
    TOP_UP_SCREEN_SHOW: 'top_up_screen_show',
    COMPLETE_PAGE_SHOW: 'complete_page_show',
  };
  static Sources = {
    LUCKY: 'lucky',
    CAAS: 'caas',
  };

  static trigger(name, source, parameters = {}) {
    window.__CAAS__.triggerNative(window.__CAAS__.events.trackEvent, uuid(), {
      name,
      source,
      parameters,
    });
  }
}
